import React from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

const LoadingButton = ({ isLoading, children, onChange, style }) => (
  <Button
    variant="primary"
    disabled={isLoading}
    isLoading={isLoading}
    onClick={onChange}
    style={style}
  >
    {isLoading ? (
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    ) : null}
    {children}
  </Button>
);

export default LoadingButton;
